export default __webpack_public_path__ + "static/media/bulk_archive.8e7d7be7.png";